import { Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { currentUserHasPermission } from "../../../Utils/Utilities";
import CustomizableCard from "./CustomizableCard"; // Adjust path as needed

const CustomersCard = ({
  customerData = {},
  onConnectionEntryOpen,
}) => {
  const navigate = useNavigate();
  const canAddConnections = currentUserHasPermission('ConnEntry');

  const sections = [
    {
      label: "Active",
      value: customerData.active,
      color: "text-sahi-green",
      onClick: () => navigate(`/connections?t=C&s=active`)
    },
    {
      label: "Inactive", 
      value: customerData.inactive,
      color: "text-sahi-grey",
      onClick: () => navigate(`/connections?t=C&s=inactive`)
    },
    {
      label: "Future",
      value: customerData.future,
      color: "text-sahi-green", 
      onClick: () => navigate(`/connections?t=C&s=future`)
    }
  ];

  return (
    <CustomizableCard
      title="Customers"
      icon={<Users className="md:w-5 md:h-5 w-4 h-4" />}
      iconColor="text-sahi-green"
      sections={sections}
      onAddClick={() => onConnectionEntryOpen("Customer")}
      showAddButton={canAddConnections}
    />
  );
};

export default CustomersCard;